import {hasOwnProperty} from '../utils';

export async function executeFetch(request) {
  let data = {};
  try {
    let response = await fetch(request);
    if (response.status == 204) {
      return data;
    }
    if (response.status == 404) {
      console.error(`Got 404 when requesting ${request.url}.`);
      data['errors'] = [{message: 'not found', response: response}];
      return data;
    }
    try {
      data = await response.json();
      if (!hasOwnProperty(data, 'data') && !hasOwnProperty(data, 'errors')) {
        const errorMessage = `invalid response to '${request.url}' from server: (${response.status}) ${response.statusText}`;
        console.error(errorMessage, data);
        data['errors'] = [{
          message: errorMessage,
          response: response,
        }];
      }
      if (hasOwnProperty(data, 'error')) {
        data['errors'] = [{
          message: `(${data.status}) ${data.error}: ${data.exception}`,
          response: response,
        }];
      }
    } catch (error) {
      console.error(error);
      data['errors'] = [{
        message: 'error parsing response from server: ' + error.message,
        response: response,
      }];
    }
  } catch (error) {
    data['errors'] = [{
      message: error.message,
      response: null,
    }];
  }
  return data;
}

export class FetchError extends Error {
  constructor(message, request, response, data = null) {
    super(message);
    this.request = request;
    this.response = response;
    this.data = data;
  }
}

export async function fetchWithExceptions(request) {
  let data = {};
  let response = null;
  try {
    response = await fetch(request);
  } catch (error) {
    throw new FetchError(error.message, request, null);
  }
  if (response.status == 204) {
    return data;
  }
  if (response.status == 404) {
    throw new FetchError('not found', request, response);
  }
  try {
    data = await response.json();
  } catch (error) {
    throw new FetchError(`error parsing response from server: ${error.message}`, request, response);
  }
  if (!hasOwnProperty(data, 'data') && !hasOwnProperty(data, 'error') && !hasOwnProperty(data, 'errors')) {
    throw FetchError(`invalid response to '${request.url}' from server: ${response.status} ${response.statusText}: ${response.body.tostring()}`, request, response, data);
  }
  if (hasOwnProperty(data, 'error')) {
    throw new FetchError(data.error, request, response, data);
  }
  if (hasOwnProperty(data, 'errors')) {
    const error = data.errors[0];
    throw new FetchError(error, request, response, data);
  }
  return data;
}
